var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-user-form',{attrs:{"add-user-function":"addLogistic","link-back":"logistics-list","new-title":"Nový logistik","title":"Logistik"}})}
var staticRenderFns = []

export { render, staticRenderFns }